import { __exportAll } from "../_virtual/_rolldown/runtime.js";
//#region src/services/appearance_service.ts
var appearance_service_exports = /* @__PURE__ */ __exportAll({ mergeAppearances: () => mergeAppearances });
function mergeAppearances(orgAppearance, locationAppearance, Appearance) {
	return new Appearance({
		...locationAppearance.data,
		...!locationAppearance.data.customCssBuildId && orgAppearance.data.customCssBuildId && { customCssBuildId: orgAppearance.data.customCssBuildId },
		...!locationAppearance.data.customCssVitrineBuildId && orgAppearance.data.customCssVitrineBuildId && { customCssVitrineBuildId: orgAppearance.data.customCssVitrineBuildId },
		customStrings: {
			...orgAppearance.data.customStrings,
			...locationAppearance.data.customStrings
		}
	});
}
//#endregion
export { appearance_service_exports, mergeAppearances };

//# sourceMappingURL=appearance_service.js.map